import { isEqual, orderBy, sortBy } from 'lodash'
import {
  type InventoryItem,
  InventoryType,
  type InventoryDisplayItem,
  InventorySubType,
} from '@ironsight/types'

export function inventoryAccumulate(allInventory: InventoryItem[]) {
  const map = new Map<number, InventoryItem>()

  allInventory.forEach((item) => {
    if (map.has(item.inventorySubTypeId)) {
      map.get(item.inventorySubTypeId)!.quantity += item.quantity
    } else {
      map.set(item.inventorySubTypeId, { ...item })
    }
  })

  return [...map.values()]
}

export function buildDisplayInventory(
  allInventory: InventoryItem[],
  allInventoryTypes: InventoryType[],
): InventoryDisplayItem[] {
  const accumulated = inventoryAccumulate(allInventory)
  return sortBy(enrichWithInventoryTypes(accumulated, allInventoryTypes), 'inventorySubTypeName')
}

export function buildInventoryDisplayString(item: InventoryDisplayItem) {
  return `(Qty ${item.quantity}) x ${item.inventorySubTypeName} · ${item.inventoryTypeName}`
}

function enrichWithInventoryTypes(
  items: InventoryItem[],
  allInventoryTypes: InventoryType[],
): InventoryDisplayItem[] {
  const subTypeIdToTypeMap = new Map<number, InventoryType>()
  const subTypeIdToSubTypeMap = new Map<number, InventorySubType>()

  allInventoryTypes.forEach((type) => {
    type.inventorySubTypes.forEach((subType) => {
      subTypeIdToTypeMap.set(subType.id, type)
      subTypeIdToSubTypeMap.set(subType.id, subType)
    })
  })

  return items.map((item) => {
    const inventorySubType = subTypeIdToSubTypeMap.get(item.inventorySubTypeId)
    const inventoryType = subTypeIdToTypeMap.get(item.inventorySubTypeId)

    return {
      ...item,
      inventorySubTypeName: inventorySubType?.name ?? 'Unknown',
      inventoryTypeId: inventoryType?.id ?? -1,
      inventoryTypeName: inventoryType?.name ?? 'Unknown',
    }
  })
}

export function standardizeInventoryList(
  inventories: {
    inventorySubTypeId: number | null
    quantity: number | null
  }[],
) {
  const sortFields = ['inventorySubTypeId', 'quantity']
  return orderBy(
    inventories.map((x) => ({
      quantity: x.quantity,
      inventorySubTypeId: x.inventorySubTypeId,
    })),
    sortFields,
  )
}
